// strings need to match with playerglobal/text/engine/FontLookup
export var FontLookUpMode;
(function (FontLookUpMode) {
    FontLookUpMode["DEFAULT"] = "DEFAULT";
    FontLookUpMode["DEVICE"] = "device";
    FontLookUpMode["EMBED_CFF"] = "embeddedCFF";
})(FontLookUpMode || (FontLookUpMode = {}));
